module.exports = __webpack_public_path__ + "img/left.62c7ae81.png";